export default {
  address: Array(),
};